export default __webpack_public_path__ + "static/media/right.466cbb54.svg";